var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.env === 'production')?_c('div',[_c('a',{staticClass:"icons logo-ores",attrs:{"href":_vm.$t('https://www.ores.be')}})]):_c('div',[_c('router-link',{staticClass:"icons logo-ores",attrs:{"to":{ name: 'home-page' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }